<template>
  <b-row>
    <b-col>
      <b-row>
        <b-col lg="8" cols="12">
          <md-field md-clearable>
            <label>Search by tenant, address, status, etc</label>
            <md-input v-model="searchInput"></md-input>
          </md-field>
        </b-col>
        <b-col lg="3" cols="0">
          <md-button
            class="md-raised md-primary play-cta-button makeup"
            @click="startNewDeal()"
          >New Deal</md-button>
        </b-col>
      </b-row>
      <md-table
        v-if="filteredDeal"
        v-model="filteredDeal"
        md-sort="name"
        md-sort-order="asc"
        md-card
      >
        <md-table-row
          slot="md-table-row"
          slot-scope="{ item }"
          @click="viewDeal(item)"
          :class="{ 'clickable': !item.loading }"
        >
          <md-table-cell v-if="item.loading" md-label="Property" md-sort-by="location">loading...</md-table-cell>
          <!-- <md-table-cell
            v-if="!item.loading"
            md-label="Property"
            md-sort-by="location"
          >{{getDisplayAddress(item.property.address)}}</md-table-cell>-->
          <md-table-cell
            v-if="!item.loading"
            md-label="Tenant"
            md-sort-by="tenant"
          >{{item.lesseeDet.privatePerson.givenName | capitalize}} {{item.lesseeDet.privatePerson.surname| capitalize}}</md-table-cell>
          <md-table-cell
            v-if="!item.loading"
            md-label="Person/Company"
            md-sort-by="tenant"
          >{{getTenantType(item.lesseeDet)}}</md-table-cell>

          <md-table-cell
            v-if="!item.loading && !item.contractDetails.terms.periodEnd"
            md-label="Term"
            md-sort-by="period"
          >Move in: {{getMoveInDate(item)}}</md-table-cell>
          <md-table-cell
            v-else-if="!item.loading"
            md-label="Term"
            md-sort-by="period"
          >{{getMoveInDate(item)}} - {{getMoveOutDate(item)}}</md-table-cell>
          <md-table-cell v-if="!item.loading" md-label="Status">
            <md-button
              id="status-cta-button"
              :disabled="isStatusCtaDisabled(item)"
              :class="getStatusCTAClass(item)"
              class="md-primary"
            >{{getBookingStatus(item)}}</md-button>
          </md-table-cell>
        </md-table-row>
      </md-table>
    </b-col>

    <error-snackbar
      :message="errorSnackbarMessage"
      :duration="Number(4000)"
      :showSnackbar="showErrorSnackbar"
      position="center"
      :isInfinity="false"
    ></error-snackbar>
  </b-row>
</template>

<script>
import { ContentLoader } from "vue-content-loader";
import { mapState } from "vuex";
import { composeChatRedirectParams } from "../../chatRepository.js";
import Snackbar from "../../components/snackbar.vue";
import { getFormattedAdrWithApartment } from "../../listings/location/locationService.js";
import { formatISOShortToDDMonthYYYY } from "../../timeFunctions.js";
import { filterDealsBasedOn } from "../../searchFunctions.js";
import { formatAddress_MuniStreetBuilding_Number } from "@/utils/address/addressUtil.js";
import { BOOKING_STATUS, BOOKING_PAYMENT_STATUS, isBookingPendingForOwnerConfirmation } from "@/bookings/bookingUtil";
export default {
  props: {
    deals: {
      type: Array,
      required: true
    }
  },
  components: {
    "content-loader": ContentLoader,
    "error-snackbar": Snackbar
  },
  data() {
    return {
      blockViewDeal: false,
      searchInput: "",
      selectedBooking: {},
      selectedContractType: "tenancyAgreement",
      showStatusCtaDialog: false,
      showBookingConfirmationDialog: false,
      showBookingRequestDialog: false,
      bookingRequestPeriodStart: undefined,
      bookingRequestPeriodEnd: undefined,
      disabledBookingDates: [],
      loadingDisabledBookingDates: true,
      currentlyInProcessRequestId: -1,
      showErrorSnackbar: false,
      errorSnackbarMessage: "",
      chatClicked: false
    };
  },
  filters: {
    capitalize: function(value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    }
  },
  computed: {
    filteredDeal() {
      if (!this.searchInput) return this.deals;
      else {
        return this.customSort(filterDealsBasedOn(this.deals, this.searchInput));
      }
    }
  },
  watch: {},
  created() {},
  methods: {
    customSort(items, currentSort) {
      if(!currentSort || !items) return items;
      function compare(a, b) {
        var aSort, bSort, isALargerResult;
        if (currentSort == "updatedAt") {
          aSort = a.updatedAt;
          bSort = b.updatedAt;
          isALargerResult = 1
        }

        let comparison = 0;
        if (aSort > bSort) {
          comparison = isALargerResult;
        } else if (aSort < bSort) {
          comparison = isALargerResult * -1;
        }
        return comparison;
      }
      return items.sort(compare);
    },
    getMoveInDate(deal) {
      var periodStart = deal.contractDetails.terms.periodStart;
      if (deal.snapshots && deal.snapshots.length) {
        var latestSnapshot = this.getLatestSnapshot(deal.snapshots);
        periodStart = latestSnapshot.contractDetails.terms.periodStart;
      }
      return this.formatTime(periodStart);
    },
    getMoveOutDate(deal) {
      var periodEnd = deal.contractDetails.terms.periodEnd;
      if (deal.snapshots && deal.snapshots.length) {
        var latestSnapshot = this.getLatestSnapshot(deal.snapshots);
        periodEnd = latestSnapshot.contractDetails.terms.periodEnd;
      }
      return this.formatTime(periodEnd);
    },
    startNewDeal() {
      this.$emit("emitStartNewDeal");
    },
    getLatestSnapshot(snapshots) {
      // snapshots are alreadyordered
      return snapshots[0].snapshot;
    },
    getLinkToUser(user) {
      return "/#/user/" + user.connectroDet.maaklerID;
    },
    isStatusCtaDisabled(deal) {
      if (deal.type != "import" && isBookingPendingForOwnerConfirmation(deal)) return false
      return true;
    },
    getStatusCTAClass(deal) {
      var classes = ["status-cta-btn"];
      if (deal.type == "import") return classes;

      deal.status === BOOKING_STATUS.accepted
        ? classes.push("confirmed-button")
        : void 0;
      deal.status === BOOKING_STATUS.declined || (deal.status === BOOKING_PAYMENT_STATUS.payment_cancelled || deal.paymentStatus === BOOKING_PAYMENT_STATUS.payment_cancelled)
        ? classes.push("declined-button")
        : void 0;
      deal.status === BOOKING_STATUS.cancelled
        ? classes.push("cancelled-button")
        : void 0;
      return classes;
    },
    performStatusCta(deal) {
      this.emitCheckCurrUserValidity();
      this.selectedBooking = deal;
      this.showStatusCtaDialog = true;
    },
    getBookingStatus(deal) {
      if (deal.type == "import") return "MANUAL";
      if (isBookingPendingForOwnerConfirmation(deal)) return "ACTION REQUIRED";
      if (deal.status === BOOKING_STATUS.accepted) return "ACCEPTED";
      if (deal.status === BOOKING_STATUS.created) return "CREATED";
      if (deal.status === BOOKING_STATUS.declined) return "DECLINED";
      if (deal.status === BOOKING_STATUS.cancelled) return "CANCELLED";
    },
    getTenantType(lesseeDet) {
      if (lesseeDet.rep == "private") {
        return "Person";
      }
      if (lesseeDet.rep == "juridical") {
        if (lesseeDet.jurPerson && lesseeDet.jurPerson.name)
          return lesseeDet.jurPerson.name;
        else return "Company";
      }
    },
    getDisplayAddress(addressObj) {
      return formatAddress_MuniStreetBuilding_Number(addressObj);
    },
    emitCheckCurrUserValidity() {
      this.$emit("emitCheckCurrUserValidity");
    },
    changeBookingStatus(bookingId, status) {
      this.$store.commit("UPDATE_BOOKING_STATUS", {
        dealId: bookingId,
        status: status
      });
    },
    reload() {
      this.$store.dispatch("getAccountDeals", {
        accountId: this.selectedAccountId,
        reload: true
      });
    },
    redirectTo(where) {
      this.$router.push({
        name: where
      });
    },
    orderItems(items) {
      if (items) {
        function compare(a, b) {
          const rA = a.updatedAt;
          const rB = b.updatedAt;

          let comparison = 0;
          if (rA < rB) {
            comparison = 1;
          } else if (rA > rB) {
            comparison = -1;
          }
          return comparison;
        }
        return items.sort(compare);
      }
    },
    isPresentInArray(ar, findMe) {
      if (!ar) return false;
      var len = ar.length;
      var i = 0;
      for (; i < len; ) {
        if (ar[i] == findMe) return true;
      }
      return false;
    },
    notifyError(title, msg) {
      this.$notify({
        title: title,
        message: msg
      });
    },
    formatTime(dateString) {
      return formatISOShortToDDMonthYYYY(dateString);
    },
    viewDeal(deal) {
      if (deal.loading) return;
        this.$router.push({
          name: "deal",
          params: {
            dealId: deal._id,
            snapshotId: deal.snapshotId,
            ownerViewingForced: true,
            redirect: "manage"
          }
        });
    }
  }
};
</script>
<style scoped lang="scss">
@import "../../assets/styles/dashboard.css";
@import "../../assets/styles/global.css";
@import "../../assets/styles/variables.scss";

.booking-request-content-container {
  padding: 1em;
}

.status-cta-btn {
  font-weight: bold !important;
  border-radius: 10px;
  border: 0px;
  font-size: 14px;
  font-weight: 400;
  padding: 8px;
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2),
    0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
}

.confirmed-button {
  background-color: $fresh-green !important;
  font-weight: 400 !important;
  color: white !important;
}
.declined-button {
  font-weight: 400 !important;
  color: $red-orange !important;
  border-radius: 10px !important;
  border: solid 1px $red-orange !important;
  background-color: white !important;
}

.cancelled-button {
  background-color: $play-yellow !important;
  font-weight: 400 !important;
  color: white !important;
}
</style>



// WEBPACK FOOTER //
// src/components/deals/dealDescriptors.vue